<template>
  <div class=" w-10/12">
    <div class=" flex flex-col ">
      <div class="w-full">
        <Tab
          :tabs="$store.state.subscription && $store.state.subscription.plan === 'basic'
            ? basicTab
            : tabs
          " 
          border
          :active-tab="currentTab"
          @currentTab="currentTab = $event"
        />
      </div>
      <div style="height:100%" v-if="loading">
        <loader size="xxs" :loader-image="false" />
      </div>
      <div v-else class=" mt-7 flex-grow">
        <pay-settings v-if="currentTab === 'Payroll Settings'"
          :employee-details="employeeDetails"
          :other-benefit-data="otherBenefitData"
        />
        <annual-gross
          v-if="currentTab === 'Salary Breakdown'"
          :gross-earnings-data="grossEarningsData"
          :total-gross-earning="totalGrossEarning"
          :expected-net-pay="expectedNetPay"
          :expected-nhf-pay="expectedNhfPay"
          :expected-paye-pay="expectedPayePay"
          :expected-pension-pay="expectedPensionPay"
          :expected-nhis-pay="expectedNhisPay"
          :expected-wht-amount="expectedWhtAmount"
          @grossPay="getPaysettings()"
        />
        <!-- <other-benefits
          v-if="currentTab === 'Other Benefits'"
          :other-benefit-data="otherBenefitData"
          @submit="getPaysettings()"
        /> -->
        <work-hours v-if="currentTab === 'Work Hours'" />
        <account-info v-if="currentTab === 'Remittance Accounts'" />
        <div v-if="currentTab === 'error'">
          <h1 class="font-bold text-xl text-center">
            Admin has not updated your Pay information
          </h1>
        </div>
      </div>
      <!-- <divider class="my-8" /> -->
      <div class="flex mb-5">
        <div class="flex mt-4 flex-grow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import { mapState } from "vuex";

// import Divider from "@/components/divider";
import PaySettings from "./paySettings"
import AccountInfo from "./accountInfo";
import OtherBenefits from "./otherBenefits";
import AnnualGross from "./annualGross";
import WorkHours from "./workHours";

export default {
  name: "PayInfo",
  components: {
    // Divider,
    Tab,
    PaySettings,
    AnnualGross,
    AccountInfo,
    OtherBenefits,
    WorkHours
  },

  data() {
    return {
      states: [],
      loading: true,
      currentTab: 'Payroll Settings',
      grossEarningsData: [],
      annualGrossPay: "",
      totalGrossEarning: 0,
      otherBenefitData: [],
      expectedNetPay: 0,
      expectedNhfPay: 0,
      expectedPayePay: 0,
      expectedPensionPay: 0,
      expectedNhisPay: 0,
      expectedWhtAmount: 0,
      tabs:[
        'Payroll Settings',
        'Salary Breakdown',
        'Work Hours',
        'Remittance Accounts'
      ],
      basicTab: ["Payroll Settings", "Salary Breakdown", "Remittance Accounts"],
    };
  },
  computed: {
    ...mapState({
      employeeDetails: state => state.employee.allEmployeeDetails
    })
  },
  methods: {
    getPaysettings() {
      this.$_getEmployeePaySetting({
        employeeId: this.employeeDetails.id
      }).then(result => {
        const {
          annualGrossEarnings,
          expectedNetPay,
          expectedNhfPay,
          expectedPayePay,
          expectedPensionPay,
          expectedNhisPay,
          expectedWhtAmount,
          otherEarnings,
          grossEarningsTotalAmount,
          otherEarningsTotalAmount,
          totalGross
        } = result.data;
        this.grossEarningsData = annualGrossEarnings;
        this.expectedNetPay = expectedNetPay;
        this.expectedNhfPay = expectedNhfPay;
        this.expectedPayePay = expectedPayePay;
        this.expectedPensionPay = expectedPensionPay;
        this.expectedNhisPay = expectedNhisPay;
        this.expectedWhtAmount = expectedWhtAmount;
        this.otherBenefitData = otherEarnings || [];
        this.totalOtherEarning = otherEarningsTotalAmount;
        this.totalGrossEarning = { grossEarningsTotalAmount, totalGross };
        this.loading = false;
      }).catch((err)=> {
          this.$toasted.error(err.response.data.message, {
            duration: 5000
          });
      });
    }
  },
  async mounted() {
    await this.$store.dispatch("employee/getOneEmployeeAll", this.$AuthUser.id);
    await this.getPaysettings();
  }
};
</script>

<style lang="scss" scoped>
.payInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  &_fakeInput {
    background: #f7f7ff;
    border-color: #878e99;
    padding: 10px 15px;
    max-height: 40px;
  }
  &_disabled {
    padding: 10px 15px;
    min-height: 40px;
    background: #eeeeee;
    border-color: #878e99;
  }
  &_unallocated {
    padding: 12px 16px;
    background: #fff5f5;
    border-color: #ea3c53;
    max-height: 65px;
  }
}
</style>
